import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpService } from '../http.service';
import { ApiService } from './api.service';
import { UserWelcomeMessage } from '@shared/entities/userWelcomeMessage';

const LOG_PREFIX = '[Api][UserWelcomeMessage] ';

@Injectable({
  providedIn: 'root'
})
export class UserWelcomeMessageService extends ApiService<UserWelcomeMessage> {
  constructor(private httpService: HttpService) {
    const masterUrl = '/users/welcome-message';
    const detailUrl = '/users/welcome-message';
    super(UserWelcomeMessage, masterUrl, detailUrl, undefined, 'user-form');
  }

  getWelcomeMessage(lang?: string): Observable<UserWelcomeMessage> {
    this.logger.debug(LOG_PREFIX + 'getWelcomeMessage', { lang });
    const url = lang ? `users/welcome-message?lang=${lang}` : 'users/welcome-message';
    return this.httpService.httpGet(url).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'getWelcomeMessage success', response);
        const wm = response.userWelcomeMessage || {};
        return {
          id: wm.id,
          subject: wm.subject || '',
          message: wm.message || '',
          lang: wm.lang || lang,
          createdDate: wm.createdDate
        } as UserWelcomeMessage;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'getWelcomeMessage error', error);
        return of({ subject: '', message: '', lang: lang } as UserWelcomeMessage);
      })
    );
  }

  saveWelcomeMessage(messageData: UserWelcomeMessage): Observable<UserWelcomeMessage | null> {
    if (messageData.id) {
      return this.updateWelcomeMessage(messageData, messageData.id.toString());
    } else {
      return this.createWelcomeMessage(messageData);
    }
  }

  createWelcomeMessage(messageData: UserWelcomeMessage): Observable<UserWelcomeMessage | null> {
    this.logger.debug(LOG_PREFIX + 'createWelcomeMessage', messageData);
    return this.save(messageData).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'createWelcomeMessage success', response);
        return response || messageData;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'createWelcomeMessage error', error);
        return of(error);
      })
    );
  }

  updateWelcomeMessage(messageData: UserWelcomeMessage, messageId: string): Observable<UserWelcomeMessage | null> {
    this.logger.debug(LOG_PREFIX + `updateWelcomeMessage with id: ${messageId}`, messageData);
    return this.save(messageData, messageId).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'updateWelcomeMessage success', response);
        return response || messageData;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'updateWelcomeMessage error', error);
        return of(error);
      })
    );
  }
}
